'use strict';
var App = (function(proj) {
    var $html,
        $body = $('body'),
        loader = '<div class="loader"></div>',
        show_loader = true;
    var $grid;
    var slides;
    var _sessionId;

    function init( options ) {

        var defaults = {};
        var settings = $.extend({}, defaults, options);

        $html = $(document.documentElement).removeClass('no-js').addClass('js');
        this.interfaceName = $(document.body).data('interface-name');
        if ( location.toString().match(/SESS_ID=(\d+)/) ) {
            _sessionId = RegExp.$1;
        }

        $('input[type=checkbox], input[type=radio], input[type=file], select').styler();

        objectFitImages('.header__middle-bg img');

        $(window).stellar({
            //scrollProperty: 'position',
            //positionProperty: 'position',
            hideDistantElements: true,
        });
    }

    function showActivity() {
        if (show_loader) {
            if ( $.fancybox ) {
                $.fancybox.showLoading();  // v.2
            } else {
                $body.append(loader);
            }
        }
    }

    function hideActivity() {
        if ( $.fancybox ) {
            $.fancybox.hideLoading();  // v.2
        } else {
            $('.loader').remove();
        }
    }

    function getCssSize( element, property ) {
        return parseFloat( $(element).css(property).replace('%', '') );
    }

    function getJSON( action, data, handler, options ) {
        App.showActivity();
        if ( _sessionId ) {
            data.SESS_ID = _sessionId;
        }
        var url = '/json/' + action + '/';
        var errorMessage = 'Произошла ошибка при загрузке данных. Попробуйте перезагрузить страницу.';
        var settings = $.extend({
            method:    'POST',
            data:       data,
            dataType:  'json',
            checkStatus: true,
            error: function() {
                alert(errorMessage);
            },
            complete: function() {
                App.hideActivity();
            }
        }, options || {});

        settings.success = function( data, textStatus, jqXHR ) {
            if ( !settings.checkStatus || data.status ) {
                handler(data, textStatus, jqXHR);
            } else {
                alert(errorMessage);
            }
        };
        return $.ajax(url, settings);
    }

    function initSlider(selector, params) {
        $(selector).slick(params);
    }

    function initPopup(selector) {
        $(selector).on('click', function(e){
            var class_name = $(this).data('class_name');
            var form_name = $(this).data('form_name');
            var object_id = $(this).data('object_id');
            var item_id = $(this).data('item_id');
            var wrap = '<div class="popup"><div class="popup__inner"><a href="#" class="popup__close js-popup-close"></a><div class="popup__block"></div></div></div>';
        
            e.preventDefault();
            e.stopImmediatePropagation();
            $('body').addClass('m--popup');
            $('.wrapper').append(wrap);
            $('.popup').fadeIn(500);
            $(selector+'-close').on('click', function(e){
                e.preventDefault();
                e.stopImmediatePropagation();
                $('.popup').fadeOut(function(){
                    $('.popup').remove();
                    $('body').removeClass('m--popup');
                });
            });
            $(document).click(function(e) {
                if ($(e.target).closest('.popup__inner').length) return;
                e.stopPropagation();
                e.stopImmediatePropagation();
                $('.popup').fadeOut(function(){
                    $('.popup').remove();
                    $('body').removeClass('m--popup');
                });
            });

            App.getJSON('get_'+class_name, { 'object_id': object_id, 'item_id': item_id, 'form_name': form_name }, function(data) {
                if (data.status == 'ok') {
                    //$('.popup').find('.popup__title').html(data.title);
                    $('.popup').find('.popup__block').append(data.html);
                    $('input[type=checkbox], input[type=radio], input[type=file], select').styler();
                    var $form = $('.popup').find('form');
                    $form.ajaxForm({
                        beforeSend: function(){
                            $form.find(".has-error").removeClass("has-error");
                            App.showActivity();
                        },
                        success: function(e){
                            App.hideActivity();
                            answer(e);
                        },
                        error: function(e){
                            App.hideActivity();
                        },
                        type: 'POST',
                        dataType: 'json',
                        url: '/json/submit_form/',
                    });

                }
            });

        });

        function answer(json) {
            var $form = $('.popup').find('form');
            if(json.status == 'ok'){
                if(json.errors){
                    for(var i=0;i<json.errors.length;i++){
                        var attr = ".attr-"+json.errors[i];
                        $form.find(attr).addClass("has-error");
                    }
                }else{
                    $('.popup').find('.form').html('<div class="content">'+json.html+'</div>');
                    $form.clearForm();
                }
            }
        }
    }

    function initForm(selector) {
        var $form = $(selector);
        $form.ajaxForm({
            beforeSend: function(){
                $form.find(".has-error").removeClass("has-error");
                App.showActivity();
            },
            success: function(e){
                App.hideActivity();
                answer(e);
            },
            error: function(e){
                App.hideActivity();
            },
            type: 'POST',
            dataType: 'json',
            url: '/json/submit_form/',
        });

        function answer(json) {
            var $form = $(selector);
            if(json.status == 'ok'){
                if(json.errors){
                    for(var i=0;i<json.errors.length;i++){
                        var attr = ".attr-"+json.errors[i];
                        $form.find(attr).addClass("has-error");
                    }
                }else{
                    $form.clearForm();
                    $(selector+'-message').html(json.html).fadeIn(500);
                }
                if ($('input[name=g-recaptcha-response]')) {
                    grecaptcha.reset();
                }
            }
        }
    }

    function catMenu(selector){
        $(selector+'-link').on('click', function(e){
            e.preventDefault();
            $(selector).toggleClass('is-open');
            $('.is-open').not(selector).removeClass('is-open');
        });
        $(document).click(function(e) {
            if ($(e.target).closest(selector).length) return;
            if ($(selector+'.is-open').length) {
                e.preventDefault();
                e.stopPropagation();
                $(selector).toggleClass('is-open');
            }
        });
    }

    function topContacts(selector){
        $(selector+'-link').on('click', function(e){
            e.preventDefault();
            $(selector).toggleClass('is-open');
            $('.is-open').not(selector).removeClass('is-open');

            var class_name = $(this).data('class_name');
            var object_id = $(this).data('object_id');

            App.getJSON('get_'+class_name, { 'object_id': object_id }, function(data) {
                if (data.status == 'ok') {
                    $(selector+'-block').html(data.html);
                    //$('input[type=checkbox], input[type=radio], input[type=file], select').styler();
                    //$('.popup').find('input[type=file]').styler({fileBrowse: 'прикрепить файл'});
                    var $form = $(selector+'-block').find('form');
                    $form.ajaxForm({
                        beforeSend: function(){
                            $form.find(".has-error").removeClass("has-error");
                            App.showActivity();
                        },
                        success: function(e){
                            App.hideActivity();
                            answer(e);
                        },
                        error: function(e){
                            App.hideActivity();
                        },
                        type: 'POST',
                        dataType: 'json',
                        url: '/json/submit_form/',
                    });

                }
            });
        });

        function answer(json) {
            var $form = $(selector+'-block').find('form');
            if(json.status == 'ok'){
                if(json.errors){
                    for(var i=0;i<json.errors.length;i++){
                        var attr = ".attr-"+json.errors[i];
                        $form.find(attr).addClass("has-error");
                    }
                }else{
                    $(selector+'-block').find('.form').html('<div class="content">'+json.html+'</div>');
                    $form.clearForm();
                }
            }
        }

        $(document).click(function(e) {
            if ($(e.target).closest(selector).length) return;
            if ($(selector+'.is-open').length) {
                e.preventDefault();
                e.stopPropagation();
                $(selector).toggleClass('is-open');
            }
        });
    }

    function topMenu(selector){
        $(selector+'-burger').on('click', function(e){
            e.preventDefault();
            $(selector).toggleClass('is-open');
            $('.is-open').not(selector).removeClass('is-open');
        });
        $(document).click(function(e) {
            if ($(e.target).closest(selector).length) return;
            if ($(selector+'.is-open').length) {
                e.preventDefault();
                e.stopPropagation();
                $(selector).toggleClass('is-open');
            }
        });
    }

    function fixedHeader(selector){
        $(window).scroll(function() {
            if ($(this).scrollTop() > 1){  
                $(selector).addClass('is-fixed');
            }
            else{
                $(selector).removeClass('is-fixed');
            }
        });
        $(selector+'-scroll').on('click', function(e){
            e.preventDefault();
            var height = $(selector).height();
            $("html, body").animate({
                scrollTop: height - 60
            });            
        });
    }

    function headerSlider(selector) {
        var params = {
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            dots: false,
            arrows: false,
            fade: true,
        };
        App.initSlider(selector, params);
    }

    function homeCatalog(selector) {
        var params = {
            //touchMove: true,
            infinite: false,
            autoplay: false,
            autoplaySpeed: 5000,
            dots: false,
            arrows: true,
            centerMode: true,
            centerPadding: '0',
            slidesToShow: 3,
            initialSlide: 1,
            //swipeToSlide: true,
            //adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 799,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]
        };
        App.initSlider(selector+'-slider', params);
        $(selector+'-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            //console.log($(selector+'-slider').find('.slider__item').eq(nextSlide).data('index'));
            var index = $(selector+'-slider').find('.slider__item').eq(nextSlide).data('index');
            var title = $(selector+'-group').filter('[data-index='+index+']').text();
            var href = $(selector+'-group').filter('[data-index='+index+']').attr('href');
            $(selector+'-group').removeClass('is-active').filter('[data-index='+index+']').addClass('is-active');
            $(selector+'-title').hide().html('<a href="'+href+'">'+title+"</a>").fadeIn(500);
            //console.log(title);
            //var $nav = $(slick.$slider).siblings(selector+'-nav').find('li');
            //$nav.removeClass('is-active');
            //$nav.eq(nextSlide).addClass('is-active');
            //console.log($nav);
        });
        $(selector+'-group').on('mouseover', function(){
            var index = $(this).data('index');
            //console.log(index);
            if (index != $(selector+'-slider').slick('slickCurrentSlide')) {
                $(selector+'-slider').slick('slickGoTo', index);
            }
        });
        $(selector+'-slider').slick('slickGoTo', 1);
    }

    function aboutCatalog(selector) {
/*
        var params = {
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            dots: false,
            arrows: false,
            variableWidth: true,
            centerMode: true,
        };
*/
        var params = {
            touchMove: true,
            infinite: false,
            autoplay: false,
            autoplaySpeed: 5000,
            dots: false,
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            //swipeToSlide: true,
            //adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 899,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 679,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
            ]
        };

        App.initSlider(selector+'-slider', params);
    }

    function productionSlider(selector) {
        var params = {
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            dots: false,
            arrows: true,
            variableWidth: true,
            centerMode: true,
            centerPadding: '0',
            focusOnSelect: true,
        };
        App.initSlider(selector+'-slider', params);
    }

    function actionsSlider(selector) {
        var params = {
            touchMove: true,
            infinite: false,
            autoplay: false,
            autoplaySpeed: 5000,
            dots: false,
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            prevArrow: selector+'-slider-prev',
            nextArrow: selector+'-slider-next',
            //swipeToSlide: true,
            //adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 799,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
            ]
        };

        $(selector+'-slider').on('init', function(event, slick){
            var total = Math.ceil(slick.slideCount / slick.options.slidesToScroll);
            var current = 1;
            _navData(current, total);
        });

        App.initSlider(selector+'-slider', params);

        $(selector+'-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            var total = Math.ceil(slick.slideCount / slick.options.slidesToScroll);
            var current = 1 + Math.ceil(nextSlide / slick.options.slidesToScroll);
            _navData(current, total);
        });

        $(selector+'-slider').on('reinit', function(event, slick, currentSlide, nextSlide){
            var total = Math.ceil(slick.slideCount / slick.options.slidesToScroll);
            var current = 1 + Math.ceil(nextSlide / slick.options.slidesToScroll);
            _navData(current, total);
        });
        function _navData(current, total) {
            $(selector+'-slider-total').text(total);
            $(selector+'-slider-current').text(current);
        };
    }

    function productsSlider(selector) {
        var items = $(selector).find('.slider__item');
        if (items.length > 4) { var rows = 2; }
        var params = {
            touchMove: true,
            infinite: false,
            autoplay: false,
            dots: false,
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            rows: rows,
            //slidesPerRow: 3,
            prevArrow: selector+'-slider-prev',
            nextArrow: selector+'-slider-next',
            swipeToSlide: true,
            //adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 799,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 599,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
            ]
        };

        $(selector+'-slider').on('init', function(event, slick){
            var total = 1 + Math.ceil(slick.slideCount / slick.options.slidesToScroll / 2);
            var current = 1;
            _navData(current, total);
        });

        App.initSlider(selector+'-slider', params);

        $(selector+'-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            var total = 1 + Math.ceil(slick.slideCount / slick.options.slidesToScroll / 2);
            var current = 1 + Math.ceil(nextSlide / slick.options.slidesToScroll);
            _navData(current, total);
        });

        $(selector+'-slider').on('reinit', function(event, slick, currentSlide, nextSlide){
            var total = Math.ceil(slick.slideCount / slick.options.slidesToScroll / 2);
            var current = 1 + Math.ceil(nextSlide / slick.options.slidesToScroll);
            _navData(current, total);
        });
        function _navData(current, total) {
            $(selector+'-slider-total').text(total);
            $(selector+'-slider-current').text(current);
        };
    }

    function siblingsSlider(selector) {
        var params = {
            touchMove: true,
            infinite: false,
            autoplay: false,
            autoplaySpeed: 5000,
            dots: false,
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            //swipeToSlide: true,
            //adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 899,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 679,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
            ]
        };

        App.initSlider(selector+'-slider', params);
    }

    function productGallery(selector) {
/*
        $(selector+'-gallery-item').on('click', function(e){
            console.log('Click');
            var src = $(this).data('src');
            if ($(this).hasClass('is-active')) return;
            $(selector+'-gallery-item').removeClass('is-active');
            $($(this)).addClass('is-active');
            if ($(this).hasClass('m--video')) {
                $(selector+'-gallery-big img').hide();
                $(selector+'-gallery-big div').hide().html(src).fadeIn();
            } else {
                $(selector+'-gallery-big div').hide().html('');
                $(selector+'-gallery-big img').hide().attr('src', src).fadeIn();
            }
        });
        $(selector+'-gallery-item').eq(0).trigger('click');
*/
        var params = {
            touchMove: true,
            infinite: false,
            autoplay: false,
            autoplaySpeed: 5000,
            dots: false,
            arrows: true,
            fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            //swipeToSlide: true,
            asNavFor: selector+'-gallery-small'
        };
        App.initSlider(selector+'-gallery-big', params);

        var params = {
            touchMove: true,
            infinite: false,
            autoplay: false,
            autoplaySpeed: 5000,
            dots: false,
            arrows: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            //swipeToSlide: true,
            swipe: false,
            variableWidth: true,
            focusOnSelect: true,
            asNavFor: selector+'-gallery-big'
        };
        App.initSlider(selector+'-gallery-small', params);
    }

    function initCollapse(selector) {
        $(selector+'-open').on('click', function(e) {
            e.preventDefault();
            var $block = $(this).parent(selector).find(selector+'-block');
            var height = $block.children('div').outerHeight();
            $block.animate({height: height+'px'}, 500);
            $(this).addClass('is-hidden');
            $(this).parent(selector).find(selector+'-close').removeClass('is-hidden');
        });
        $(selector+'-close').on('click', function(e) {
            e.preventDefault();
            var $block = $(this).parent(selector).find(selector+'-block');
            $block.animate({height: 0}, 500);
            $(this).addClass('is-hidden');
            $(this).parent(selector).find(selector+'-open').removeClass('is-hidden');
        });
    }

    function initVacancy(selector) {
        $(selector+'-toggle').on('click', function(e) {
            e.preventDefault();
            var $block = $(this).parent(selector).find(selector+'-block');
            $block.slideToggle(500);
            $(this).toggleClass('is-open');
        });
    }

    function showMap(selector) {
        if ($(selector).length == 0) return;
        var location = $(selector+'-block').data('location').split(',');
        var latitude = location[0];
        var longitude = location[1];
        var options = {};
        var opt = $.extend({
            mapSelector: selector+'-block',
            itemSelector: selector+'-item',
            behaviors: ['default', 'scrollZoom'],
            controls: ['zoomControl'],
            center: [latitude, longitude],
            zoom: 12,
            eps: .005
        }, options);
        if ($(opt.mapSelector).length == 0) return;
        var myMap, $map;
        var placemarks = {};

        function _init() {
            $map = $(opt.mapSelector);
            if (!$map.length) return;
            //console.log('Init map');

            var items = {};
            $(opt.itemSelector).each(function(i) {
                var id = $(this).data('object_id');
                var data = $(this).data();
                data.coords = data.coords.split(',');
                items[id] = data;
            });

            myMap = new ymaps.Map($map.get(0), {
                behaviors: opt.behaviors,
                controls: opt.controls,
                center: opt.center,
                zoom: opt.zoom
            });

            myMap.controls.add('zoomControl');
            myMap.controls.add('typeSelector');

            $map.mouseenter(function(e) {
                myMap.behaviors.disable('scrollZoom');
                //if(e.ctrlKey == true) {
                //    e.preventDefault();
                //    myMap.behaviors.enable('scrollZoom');
                //}
            });

            var MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
                '<div class="popover">' +
                '<a class="popover__close" href="#">&times;</a>' +
                '<div class="popover__inner">' +
                '$[[options.contentLayout observeSize minWidth=235 maxWidth=235 maxHeight=350]]' +
                '</div>' +
                '</div>', {
                build: function () {
                    this.constructor.superclass.build.call(this);

                    this._$element = $('.popover', this.getParentElement());

                    this.applyElementOffset();

                    this._$element.find('.popover__close')
                        .on('click', $.proxy(this.onCloseClick, this));
                },
                clear: function () {
                    this._$element.find('.popover__close')
                        .off('click');

                    this.constructor.superclass.clear.call(this);
                },
                onSublayoutSizeChange: function () {
                    MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                    if(!this._isElement(this._$element)) {
                        return;
                    }

                    this.applyElementOffset();

                    this.events.fire('shapechange');
                },
                applyElementOffset: function () {
                    this._$element.css({
                        left: -(this._$element[0].offsetWidth / 2),
                        top: -(this._$element[0].offsetHeight)
                    });
                },
                onCloseClick: function (e) {
                    e.preventDefault();

                    this.events.fire('userclose');
                },
                getShape: function () {
                    if(!this._isElement(this._$element)) {
                        return MyBalloonLayout.superclass.getShape.call(this);
                    }
                    var position = this._$element.position();
                    return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                        [position.left, position.top], [
                            position.left + this._$element[0].offsetWidth,
                            position.top + this._$element[0].offsetHeight
                        ]
                    ]));
                },
                _isElement: function (element) {
                    return element && element[0];
                }
            });

            var MyBalloonContentLayout = ymaps.templateLayoutFactory.createClass(
                '<div class="popover__content">$[properties.balloonContent]</div>'
            );

            var geoobjects = [];
            for (var j in items) {
                if (items[j].coords.length == 2) {
                    var myGeoObject = new ymaps.GeoObject({
                            geometry: {
                                type: "Point",
                                coordinates: items[j].coords
                            },
                            properties: {
                                //clusterCaption: annotation,
                                //content: items[j].info,
                                balloonContent: items[j].info,
                            }
                        }, {
                            balloonShadow: false,
                            balloonLayout: MyBalloonLayout,
                            balloonContentLayout: MyBalloonContentLayout,
                            balloonPanelMaxMapArea: 0,
                            hideIconOnBalloonOpen: false,
                            iconLayout: 'default#image',
                            iconImageHref: '/i/map-label.png',
                            iconImageSize: [60, 60],
                            iconImageOffset: [-30, -30],
                    });
                    geoobjects.push(myGeoObject);
                    //console.log('Add Geo Object', myGeoObject);
                }
            }
            if (geoobjects.length) {
                var clusterer = new ymaps.Clusterer({clusterDisableClickZoom: false});
                clusterer.add(geoobjects);
                myMap.geoObjects.add(clusterer);
                //console.log('Set Goe Object');
            }
        }
        function _resize() {
            var wheight = $(window).height();
            var hheight = $('.header').height();
            var fheight = $('.footer').height();
            var moffset = $(opt.mapSelector).offset().top;
            var mheight = wheight - hheight - fheight - moffset;
            $(opt.mapSelector).height(mheight);
            //console.log(wheight,hheight,fheight,moffset);
        }

        $(window).on('resize', function(){
            //_resize();
        });
        //_resize();
        _init();
    }

    function buyersMap(selector) {
        if ($(selector).length == 0) return;
        var location = $(selector+'-item').eq(0).data('coords').split(',');
        var latitude = location[0];
        var longitude = location[1];
        var options = {};
        var opt = $.extend({
            mapSelector: selector+'-block',
            itemSelector: selector+'-item',
            behaviors: ['default', 'scrollZoom'],
            controls: ['zoomControl'],
            center: [latitude, longitude],
            zoom: 15,
            eps: .005
        }, options);
        if ($(opt.mapSelector).length == 0) return;
        var myMap, $map;
        var placemarks = {};

        function _init() {
            $map = $(opt.mapSelector);
            if (!$map.length) return;
            console.log('Init map');

            myMap = new ymaps.Map($map.get(0), {
                behaviors: opt.behaviors,
                controls: opt.controls,
                center: opt.center,
                zoom: opt.zoom
            });

            var coords = $(selector+'-item').eq(0).data('coords').split(',');
            $(selector+'-item').eq(0).addClass('is-active');

            var myGeoObject = new ymaps.GeoObject({
                    geometry: {
                        type: "Point",
                        coordinates: coords
                    },
                    properties: {
                        //clusterCaption: annotation,
                        //content: items[j].info,
                        //balloonContent: items[j].info,
                    }
                }, {
                    //balloonShadow: false,
                    //balloonLayout: MyBalloonLayout,
                    //balloonContentLayout: MyBalloonContentLayout,
                    //balloonPanelMaxMapArea: 0,
                    //hideIconOnBalloonOpen: false,
                    iconLayout: 'default#image',
                    iconImageHref: '/i/map-label.png',
                    iconImageSize: [60, 60],
                    iconImageOffset: [-30, -30],
            });

            myMap.geoObjects.add(myGeoObject);

            myMap.controls.add('zoomControl');
            myMap.controls.add('typeSelector');

            $(selector+'-item').on('click', function(e){
                e.preventDefault();
                $(selector+'-item').removeClass('is-active');
                var coords = $(this).data('coords').split(',');
                $(this).addClass('is-active');
                myGeoObject.geometry.setCoordinates(coords);
                myMap.setCenter(coords);
            });

            $map.mouseenter(function(e) {
                myMap.behaviors.disable('scrollZoom');
                //if(e.ctrlKey == true) {
                //    e.preventDefault();
                //    myMap.behaviors.enable('scrollZoom');
                //}
            });

            var params = {
                touchMove: true,
                infinite: false,
                autoplay: false,
                autoplaySpeed: 5000,
                dots: false,
                arrows: true,
                slidesToShow: 9,
                slidesToScroll: 9,
                prevArrow: selector+'-slider-prev',
                nextArrow: selector+'-slider-next',
                //swipeToSlide: true,
                //adaptiveHeight: true,
                vertical: true,
                verticalSwiping: true,
                responsive: [
                    {
                        breakpoint: 9999,
                        settings: {
                            slidesToShow: 9,
                            slidesToScroll: 9,
                        }
                    },
                    {
                        breakpoint: 959,
                        settings: {
                            variableWidth: true,
                            vertical: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                ]
            };

            $(selector+'-slider').on('init', function(event, slick){
                var total = Math.ceil(slick.slideCount / slick.options.slidesToScroll);
                var current = 1;
                _navData(current, total);
            });

            App.initSlider(selector+'-slider', params);

            $(selector+'-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
                var total = Math.ceil(slick.slideCount / slick.options.slidesToScroll);
                var current = 1 + Math.ceil(nextSlide / slick.options.slidesToScroll);
                _navData(current, total);
            });

            $(selector+'-slider').on('reinit', function(event, slick, currentSlide, nextSlide){
                var total = Math.ceil(slick.slideCount / slick.options.slidesToScroll);
                var current = 1 + Math.ceil(nextSlide / slick.options.slidesToScroll);
                _navData(current, total);
            });
            function _navData(current, total) {
                $(selector+'-slider-total').text(total);
                $(selector+'-slider-current').text(current);
            };
        }
        _init();
    }

    function homeVideo(selector) {
        var video = document.querySelector(selector);
        var $video = $(selector);
        if ($video.length == 0) {
            return;
        }
        var promise = video.play();
        if (promise === undefined) {
            console.log('Promisified video play() not supported');
        } else {
            promise.then(function() {
                console.log('Video playback successfully initiated, returning a promise');
            }).catch(function(error) {
                console.log('Error initiating video playback: ', error);
            });
        }
        video.addEventListener('ended',function() {
            //v=video.currentSrc;
            video.src='';
            //video.src=v;  
        },false);
    }

//------------------------------------------------------------------------------
//------------------------------------------------------------------------------

    proj.init =              init;
    proj.showActivity =      showActivity;
    proj.hideActivity =      hideActivity;
    proj.getCssSize =        getCssSize;
    proj.getJSON =           getJSON;
    proj.initSlider =        initSlider;

    //proj.initForm =          initForm;

    proj.fixedHeader =       fixedHeader;
    proj.headerSlider =      headerSlider;
    proj.topMenu =           topMenu;
    proj.topContacts =       topContacts;
    proj.catMenu =           catMenu;
    proj.homeCatalog =       homeCatalog;
    proj.aboutCatalog =      aboutCatalog;
    proj.actionsSlider =     actionsSlider;
    proj.productsSlider =    productsSlider;
    proj.siblingsSlider =    siblingsSlider;
    proj.productGallery =    productGallery;
    proj.productionSlider =  productionSlider;
    proj.initCollapse =      initCollapse;
    proj.initVacancy =       initVacancy;
    proj.initPopup =         initPopup;
    proj.showMap =           showMap;
    proj.buyersMap =         buyersMap;
    proj.homeVideo =         homeVideo;
    return proj;

})(App || {});